/* Reya · Tabs — accessible tablist that swaps server-rendered panels and syncs a "view all" link */
if (!customElements.get('rr-tabs')) {
  customElements.define(
    'rr-tabs',
    class RrTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        if (!this.tabs.length) return;
        this.viewAll = this.querySelector('[data-rr-viewall]');
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            const n = this.tabs.length;
            let j = null;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n;
            else if (e.key === 'Home') j = 0;
            else if (e.key === 'End') j = n - 1;
            if (j === null) return;
            e.preventDefault();
            this.select(j);
            this.tabs[j].focus();
          });
        });
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.indexOf(e.target);
          if (i > -1) this.select(i);
        });
      }

      select(i) {
        this.tabs.forEach((tab, k) => {
          const on = k === i;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (on) {
            if (window.Reya && window.Reya.initReveal) window.Reya.initReveal(panel);
            const track = panel.querySelector('[data-rr-scroller]');
            if (track) track.dispatchEvent(new Event('scroll'));
          }
        });
        const tab = this.tabs[i];
        if (this.viewAll && tab.dataset.url) {
          this.viewAll.href = tab.dataset.url;
          const name = this.viewAll.querySelector('[data-rr-viewall-name]');
          if (name) name.textContent = ' ' + (tab.dataset.title || tab.textContent.trim());
        }
      }
    }
  );
}
